import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import env from 'environment';
import ChooseAmountCard from 'components/Common/ChooseAmountCard/ChooseAmountCard';
import { ContributionWarningModal } from 'components/Common/ChooseAmountCard/ContributionWarningModal';

const CapitalFundDonationsChooseAmount = () => {
  const location = useLocation();
  const history = useHistory();
  const [isShowModal, setIsShowModal] = useState(false);
  const [chosenContributionInfo, setChosenContributionInfo] = useState(null);
  const granteeId = location.state?.grantId;
  const granteeName = location.state?.grantName ?? 'Donor-advised fund account opening donation';
  const achDonationsBottomQuantityUrl = `${env.CAPITAL_FUND_GRANTEE_DONATION_BOTTOM_QUANTITY_URL}?dt_grantee_id=${granteeId}&donors_trust_grantee_name=${granteeName}`;
  const achDonationsUpperQuantityUrl = `${env.CAPITAL_FUND_GRANTEE_DONATION_UPPER_QUANTITY_URL}?dt_grantee_id=${granteeId}&donors_trust_grantee_name=${granteeName}`;

  return (
    <>
      <div className="grant-request mt-n3 mt-md-n4">
        <div className="grant-instructions text-center p-3 p-md-5">
          <h2>
            <strong>Choose amount of contribution</strong>
          </h2>
        </div>
      </div>
      <div className="container mt-5">
        <div className="d-flex justify-content-between flex-column flex-md-row ach-contribution-cards-wrapper">
          {' '}
          <ChooseAmountCard
            text={
              <div>
                To request a contribution amount less than $8,500.00, click on the link below.
                <br />
                <br />
                Once you click, you will be redirected to the appropriate payment form.
              </div>
            }
            navigation={
              <button
                type="button"
                className="button text-link"
                onClick={() => {
                  setChosenContributionInfo({
                    url: achDonationsBottomQuantityUrl,
                    isGreater8500: false,
                  });
                  setIsShowModal(true);
                }}
              >
                <strong>Contribute &lt; $8,500.00</strong>
              </button>
            }
          />
          <ChooseAmountCard
            text={
              <div>
                To request a contribution amount greater or equal to $8,500.00, click on the link
                below.
                <br />
                <br />
                Once you click, you will be redirected to the appropriate payment form.
              </div>
            }
            navigation={
              <button
                type="button"
                className="button text-link"
                onClick={() => {
                  setChosenContributionInfo({
                    url: achDonationsUpperQuantityUrl,
                    isGreater8500: true,
                  });
                  setIsShowModal(true);
                }}
              >
                <strong>Contribute &ge; $8,500.00</strong>
              </button>
            }
          />
        </div>
        <div className="mt-5 d-flex justify-content-end">
          <button
            type="button"
            className="button button--dark-blue px-4 px-md-5 py-3 mr-0 text-center col-12 col-md-auto"
            onClick={() =>
              history.push({ pathname: '/capital-fund-grantee/achcontribution/choose' })
            }
          >
            Back
          </button>
        </div>
      </div>
      {isShowModal && (
        <ContributionWarningModal
          isShowModal={isShowModal}
          setIsShowModal={(value) => setIsShowModal(value)}
          chosenContributionInfo={chosenContributionInfo}
        />
      )}
    </>
  );
};
export default CapitalFundDonationsChooseAmount;
